module.exports = __webpack_public_path__ + "static/img_1264-5393c66c8a63e2dca3a25cd627a3a758.webp";